import { render } from "./LogoGrid.vue?vue&type=template&id=36933a1e&bindings={\"small_title\":\"props\",\"logos\":\"props\"}"
import script from "./LogoGrid.vue?vue&type=script&lang=js"
export * from "./LogoGrid.vue?vue&type=script&lang=js"
script.render = render

export default script